import React, { useEffect, useState } from 'react';
import { subscribe, unsubscribe } from '../shared/events';
import { v4 as uuidv4 } from 'uuid';
import ConfirmModal from './ConfirmModal';
import AlertModal from './AlertModal';

export default function ModalManager() {
  const [Modals, SetModals] = useState([]);

  const modalTypes = [
    { event: 'showConfirmModal', type: 'confirm', component: ConfirmModal },
    { event: 'showAlertModal', type: 'alert', component: AlertModal }
  ];

  useEffect(() => {
    const listeners = modalTypes.map(({ event, type }) => {
      const listener = (e) => {
        SetModals(prev => [...prev, { id: uuidv4(), type, ...e.detail }]);
      };
      subscribe(event, listener);
      return { event, listener };
    });

    return () => {
      listeners.forEach(({ event, listener }) => unsubscribe(event, listener));
    };
  }, []);

  const removeModal = (id) => {
    SetModals(prev => prev.filter(m => m.id !== id));
  };

  return (
    <>
      {Modals.map(modal => {
        const ModalComponent = modalTypes.find(t => t.type === modal.type)?.component;
        return ModalComponent ? (
          <ModalComponent key={modal.id} {...modal} onClose={() => removeModal(modal.id)} />
        ) : null;
      })}
    </>
  );
}
